import React from "react"
import { Table } from "react-bootstrap"

import LoadingContainer from "../../../../../_components/LoadingContainer"
import { getNFeTransporters } from "../../../../../api/nfe"
import Text from "../../../../../_components/Text"
import IconButton from "../../../../../_components/IconButton"
import { formatDocument } from "../../../../../utils"

import CreateTranporter from "../CreateTranporter"
import Transporter from "../Transporter"

export default props => {

    const ref = React.useRef(null)
    const [show, setShow] = React.useState(false)
    const [data, setData] = React.useState([])
    const [selectedItem, setSelectedItem] = React.useState([])
    const [loading, setLoading] = React.useState(false)

    function onHide() {
        setShow(false)
    }
    function onEditTransport(item) {
        setShow(true)
        setSelectedItem(item)
    }
    function onCreate() {
        const reaload = () => window.location.reload()
        setTimeout(reaload, 3000)
    }

    function loadData() {
        setLoading(true)
        getNFeTransporters()
            .then(_ => {
                setData(_)
                setLoading(!true)
            })
            .catch(error => {
                setLoading(!true)
            })
    }
    React.useEffect(loadData, [ref.current])

    return <div className="container" ref={ref}>
        <div className="row">
            <div className="col-12 py-3">
                <Text as="h1">
                    Transportadoras
                </Text>
                    <Transporter show={show} data={selectedItem} onHide={onHide}/>
            </div>
        </div>
        <div className="row">
            <LoadingContainer loading={loading}>
                <div className="col-12">
                    <Table striped bordered hover responsive >
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>Nome</th>
                                <th>CPF/CNPJ</th>
                                <th>IE</th>
                                <th>Cidade</th>
                                <th>Ações</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                data.map((item, idx) => {
                                    const cpfCnpj = formatDocument(item.cpf || item.cnpj)
                                    return <tr key={`transport-list-item-${item.id}`}>
                                        <td>{idx + 1}</td>
                                        <td>{item.name}</td>
                                        <td>{cpfCnpj}</td>
                                        <td>{item.state_registry}</td>
                                        <td>{item.city_location.city_name}</td>
                                        <td>
                                            <IconButton icon="edit" onClick={() => onEditTransport(item)}/>
                                        </td>
                                    </tr>
                                })
                            }
                        </tbody>
                    </Table>
                </div>
            </LoadingContainer>
        </div>
    </div>
}


// WEBPACK FOOTER //
// ./src/views/Fiscal/NFe/Transport/List/index.jsx